/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
class RecipientForm extends HTMLElement {
  constructor() {
    super();
    this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
    this.checkboxInput.disabled = false;
    this.hiddenControlField = this.querySelector(`#Recipient-Control-${this.dataset.sectionId}`);
    this.hiddenControlField.disabled = true;
    this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
    this.emailConfirmInput = this.querySelector(`#Recipient-email-confirm-${this.dataset.sectionId}`);
    this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
    this.senderNameInput = this.querySelector(`#Sender-name-${this.dataset.sectionId}`);
    this.sendOnInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
    this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
    this.timezoneOffsetInput = this.querySelector(`#Recipient-Timezone-Offset-${this.dataset.sectionId}`);
    this.productForm = this.closest('form');
    this.addButton = this.productForm ? this.productForm.querySelector('[data-product-add]') : null;
    this.recipientInputs = [
      this.emailInput,
      this.emailConfirmInput,
      this.nameInput,
      this.senderNameInput,
      this.sendOnInput,
      this.messageInput,
      this.timezoneOffsetInput
    ].filter(Boolean);
  }

  connectedCallback() {
    this.addEventListener('change', this.onChange.bind(this));
    this.emailInput.addEventListener('input', this.validateEmailConfirmation.bind(this));
    this.emailConfirmInput.addEventListener('input', this.validateEmailConfirmation.bind(this));
    if (this.productForm) {
      this.productForm.addEventListener('submit', this.onSubmit.bind(this));
    }
    if (this.addButton) {
      this.addButton.addEventListener('click', this.onAddButtonClick.bind(this), true);
    }
    document.addEventListener('cart:added', this.resetRecipientForm.bind(this));
    this.toggleRecipientFields();
  }

  onChange() {
    if (!this.checkboxInput.checked) {
      this.clearInputFields();
    }

    this.toggleRecipientFields();
    this.validateEmailConfirmation();
  }

  onSubmit(event) {
    if (!this.checkboxInput.checked) return;

    if (!this.validateRecipientFields()) {
      event.preventDefault();
    }
  }

  onAddButtonClick(event) {
    if (!this.checkboxInput.checked) return;

    if (!this.validateRecipientFields()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  toggleRecipientFields() {
    this.recipientInputs.forEach((input) => {
      input.disabled = !this.checkboxInput.checked;
    });
  }

  clearInputFields() {
    this.emailInput.value = '';
    this.emailConfirmInput.value = '';
    this.nameInput.value = '';
    this.senderNameInput.value = '';
    this.sendOnInput.value = '';
    this.messageInput.value = '';
    this.timezoneOffsetInput.value = '';
  }

  validateEmailConfirmation() {
    if (!this.checkboxInput.checked || !this.emailConfirmInput.value) {
      this.emailConfirmInput.setCustomValidity('');
      return true;
    }

    const email = this.emailInput.value.trim().toLowerCase();
    const emailConfirmation = this.emailConfirmInput.value.trim().toLowerCase();
    const emailMatches = email === emailConfirmation;
    this.emailConfirmInput.setCustomValidity(emailMatches ? '' : 'Recipient email addresses must match.');

    return emailMatches;
  }

  validateRecipientFields() {
    this.timezoneOffsetInput.value = new Date().getTimezoneOffset();

    if (!this.validateEmailConfirmation()) {
      this.emailConfirmInput.reportValidity();
      return false;
    }

    const invalidInput = [this.emailInput, this.emailConfirmInput, this.nameInput].find((input) => !input.checkValidity());

    if (invalidInput) {
      invalidInput.reportValidity();
      return false;
    }

    return true;
  }

  resetRecipientForm() {
    if (this.checkboxInput.checked) {
      this.checkboxInput.checked = false;
      this.clearInputFields();
      this.toggleRecipientFields();
      this.validateEmailConfirmation();
    }
  }
}

// Define custom element if it doesn't exist already
if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', RecipientForm);
}
/******/ })()
;
